var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkendIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "#0077B5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7367 10.3977C9.643 10.3977 10.3777 9.66302 10.3777 8.75672C10.3777 7.85042 9.643 7.11572 8.7367 7.11572C7.8304 7.11572 7.0957 7.85042 7.0957 8.75672C7.0957 9.66302 7.8304 10.3977 8.7367 10.3977Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9268 11.6413V20.7455H14.7536V16.2433C14.7536 15.0553 14.9771 13.9048 16.4501 13.9048C17.9028 13.9048 17.9208 15.263 17.9208 16.3183V20.7463H20.7491V15.7535C20.7491 13.301 20.2211 11.4163 17.3546 11.4163C15.9783 11.4163 15.0558 12.1715 14.6786 12.8863H14.6403V11.6413H11.9268ZM7.32031 11.6413H10.1516V20.7455H7.32031V11.6413Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkendIn);
export default __webpack_public_path__ + "static/media/linkendIn.0ec79e9063da04e73c43de608564ff8e.svg";
export { ForwardRef as ReactComponent };